var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 10.6206C27.875 10.3385 27.7685 10.0663 27.5762 9.85986L21.5146 3.35498C21.3037 3.12875 21.0085 3.0005 20.6992 3.00049L9.61524 3.00049C8.99953 3.00049 8.50025 3.4991 8.5 4.11475L8.5 28.2349C8.5 28.8507 8.99938 29.3501 9.61523 29.3501L26.7598 29.3501C27.3756 29.3501 27.875 28.8507 27.875 28.2349L27.875 10.6206ZM9.89355 27.9565L9.89356 4.39404L18.5713 4.39404L18.5713 11.0327C18.5715 12.0331 19.3824 12.844 20.3828 12.8442L26.4814 12.8442L26.4814 27.9565L9.89355 27.9565ZM19 21.5005L12 21.5005L12 23.0005L19 23.0005L19 21.5005ZM12 17.5005L12 19.0005L19 19.0005L19 17.5005L12 17.5005ZM20.3828 11.4507C20.1522 11.4504 19.9651 11.2633 19.9648 11.0327L19.9648 4.39404L20.5781 4.39404L26.4814 10.73L26.4814 11.4507L20.3828 11.4507Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.1d657d86518c521fe0eac67fb6e3d2ab.svg";
export { ForwardRef as ReactComponent };